// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"232":"LeaderboardScreen","346":"SignupNameScreen","467":"QuestionsComplete","639":"QuestionScreenV2"}[chunkId] + "." + {"232":"ba6711f2","346":"0c2ecaef","467":"16f1866f","639":"af2efc93"}[chunkId] + ".chunk.js";
};